Bingo.HubSpot = {
    isLoaded: false,
    config: {
        liveChatId: null,
        showLiveChat: false,
    },
};

Bingo.HubSpot.init = function (config) {
    this.config = $.extend(this.config, config);
    const liveChatLink = $('.js-liveChatLoad');

    window.hsConversationsSettings = {
        loadImmediately: this.config.showLiveChat,
    };

    window.hsConversationsOnReady = [function () {
        Bingo.HubSpot.isLoaded = true;
    }];

    if (this.config.showLiveChat) {
        Bingo.HubSpot.registerScripts(this.config.liveChatId);
    }

    if (this.config.showLiveChat) {
        liveChatLink.filter('.js-liveChatLoad--toggle').toggleClass('d-none d-block');
    } else {
        liveChatLink.filter('.js-liveChatLoad--toggle').addClass('d-none');
    }

    liveChatLink.click(() => {
        Bingo.HubSpot.openChat();
    });
};

Bingo.HubSpot.openChat = function () {
    if (Bingo.HubSpot.isLoaded) {
        window.HubSpotConversations.widget.open();
    } else {
        window.hsConversationsOnReady = [function () {
            Bingo.HubSpot.isLoaded = true;
            window.HubSpotConversations.widget.load({widgetOpen: true});
        }];
        Bingo.HubSpot.registerScripts();
    }
};

Bingo.HubSpot.registerScripts = function () {
    if ($('#hs-script-loader').length > 0) {
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.src = `https://js.hs-scripts.com/${this.config.liveChatId}.js`;

    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
};
